import React from 'react'
import FinalClientPage from './FinalClientPage'

const ClientContainer = ({articleObj}) => {
  return (
     
    
    <FinalClientPage containerObject={articleObj} className="my-5"/> 

  )
}

export default ClientContainer